import { put,call, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* mailTrashListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('filter', payload.filter);
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/mailTrashListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MAIL_TRASH_LIST_SET",
        payload: {
          list: res.data.list,
          filter: action.payload.filter,
          page: action.payload.page,
          isListNext: res.data.isListNext,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* mailTrashItemRestore(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'restore');
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/mailTrashEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MAIL_TRASH_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "MAIL_GROUP_LIST_INIT",
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* mailTrashItemDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('pic', payload.pic);
    return axios.post(config.apiUri + "member/mailTrashEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      yield put({
        type: "MAIL_TRASH_ITEM_SET",
        payload: {
          type: 'del',
          pic: action.payload.pic,
        },
      });
      yield put({
        type: "MAIL_GROUP_LIST_INIT",
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('MAIL_TRASH_LIST_GET', mailTrashListGet),
  takeLatest('MAIL_TRASH_ITEM_RESTORE', mailTrashItemRestore),
  takeLatest('MAIL_TRASH_ITEM_DEL', mailTrashItemDel),
];

export default saga;
